export default __webpack_public_path__ + "static/media/vixiLogoBone.4c28d360.png";